import { SelectProps } from 'app/components/Modules/Form/typing'
import Select from 'app/components/UI-Elements/DataEntry/Select'
import { RecordType } from 'app/constants/GlobalTypes'
import { useIndex } from 'app/lib/hooks/useQuery'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import { FC, useState } from 'react'

type Props = SelectProps<IProject> & {
  onFilter: (value: unknown, option: unknown) => void
  value?: string
}

const Project: FC<Props> = ({ onFilter, value, ...props }) => {
  const [query, setQuery] = useState<string>()
  const { data, loading } = useIndex<IProject>(RecordType.project, {
    variables: {
      query,
      id: value && [value],
      withInvoices: true,
      sort: [{ sortField: 'name', sortDirection: 'desc' }]
    }
  })

  const { tRecordType } = useTranslation({
    recordType: RecordTypeEnum.project
  })
  const entries: IProject[] = data?.nodes || []
  const valueAsObject = findSelectedEntry(entries, value)

  return (
    <>
      <Select<Partial<IProject>>
        allowClear={true}
        entries={entries}
        filterOption={false}
        labelInValue={true}
        loading={loading}
        onChange={onFilter}
        onSearch={setQuery}
        placeholder={tRecordType({})}
        searchValue={query}
        selectLabelBy={'name'}
        showSearch={true}
        style={{ minWidth: 200 }}
        value={valueAsObject}
        {...props}
      />
    </>
  )
}

function findSelectedEntry(entries: IProject[], value: string) {
  const entry = entries.find(({ id }) => id.toString() === value?.toString())
  if (!entry) return null

  return { value, label: entry.name }
}

export default Project
